// extracted by mini-css-extract-plugin
export default {"Headline":"_Headline--Mdy3k","SectionWrapper":"_SectionWrapper--LjsAM","SectionDetails":"_SectionDetails--rxDvF","SemiBold":"_SemiBold--G6G8m"};